import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';
import { TuiSvgModule } from '@taiga-ui/core';
import { OrderState, OrderStateData, OrderStatus } from '@us/web/shared/data-access';
import { TuiAvatarModule } from '@taiga-ui/kit';
import { FormatPipeModule, ParseIsoPipeModule } from 'ngx-date-fns';
import { TranslocoModule } from '@ngneat/transloco';

@Component({
    selector: 'us-order-state',
    standalone: true,
    imports: [TuiSvgModule, NgIf, TuiAvatarModule, ParseIsoPipeModule, FormatPipeModule, TranslocoModule],
    templateUrl: './order-state.component.html',
    styleUrls: ['./order-state.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderStateComponent {
    @Input() item!: OrderStatus;
    @Input() standalone = false;

    readonly OrderState = OrderState;
    readonly OrderStateData = OrderStateData;
}
